import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Settings as SettingsIcon } from '@mui/icons-material';

const theme = createTheme({
    palette: {
        primary: {
            main: '#ff9800',
            contrastText: '#fff',
        },
        background: {
            default: '#fff8f0',
            paper: '#ffffff',
        },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h4: {
            fontWeight: 600,
        },
        h6: {
            fontWeight: 500,
        },
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                },
            },
        },
    },
});

const GeneralSettingsPage = () => {
    return (
        <ThemeProvider theme={theme}>
            <Container maxWidth="lg" sx={{ py: 8 }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '70vh',
                        textAlign: 'center',
                    }}
                >
                    <SettingsIcon sx={{ fontSize: 80, color: 'primary.main', mb: 2 }} />
                    <Typography variant="h4" color="primary" gutterBottom>
                        Feature Coming Soon
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        We're working hard to bring this feature to you soon. Stay tuned!
                    </Typography>
                </Box>
            </Container>
        </ThemeProvider>
    );
};

export default GeneralSettingsPage;



   // const handleManualSync = () => {
    //     // Simulate sync
    //     const newSyncTime = new Date();
    //     setLastSync(newSyncTime);
    //     localStorage.setItem('lastSyncTime', newSyncTime.toString());
    //     alert('Data synchronized successfully!');
    // };

   /* Sync Settings */
                    /* <Grid item xs={12} md={6}>
                        <Paper elevation={2} sx={{ p: 3, height: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                <SyncIcon2 color="primary" sx={{ mr: 1 }} />
                                <Typography variant="h6">
                                    Offline Sync
                                </Typography>
                            </Box>
                            <Divider sx={{ mb: 3 }} />

                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                <Typography variant="body1" sx={{ mr: 2 }}>
                                    Enable Offline Sync
                                </Typography>
                                <Switch
                                    name="enableOfflineSync"
                                    checked={settings.enableOfflineSync}
                                    onChange={handleChange}
                                    color="primary"
                                />
                            </Box>

                            {settings.enableOfflineSync && (
                                <>
                                    <Box sx={{ mb: 2 }}>
                                        <Typography variant="body1" sx={{ mb: 1 }}>
                                            Sync Interval (minutes)
                                        </Typography>
                                        <TextField
                                            name="syncInterval"
                                            type="number"
                                            value={settings.syncInterval}
                                            onChange={handleNumberChange}
                                            fullWidth
                                            inputProps={{ min: 1, max: 1440 }}
                                            variant="outlined"
                                            size="small"
                                        />
                                    </Box>

                                    <Box sx={{ mb: 2 }}>
                                        <Typography variant="body1" sx={{ mb: 1 }}>
                                            Max Retry Attempts
                                        </Typography>
                                        <TextField
                                            name="maxRetryAttempts"
                                            type="number"
                                            value={settings.maxRetryAttempts}
                                            onChange={handleNumberChange}
                                            fullWidth
                                            inputProps={{ min: 1, max: 10 }}
                                            variant="outlined"
                                            size="small"
                                        />
                                    </Box>

                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                        <Typography variant="body1" sx={{ mr: 2 }}>
                                            Sync on App Startup
                                        </Typography>
                                        <Switch
                                            name="syncOnStartup"
                                            checked={settings.syncOnStartup}
                                            onChange={handleChange}
                                            color="primary"
                                        />
                                    </Box>
                                </>
                            )}
                        </Paper>
                    </Grid> */

                    /* Notification Settings */
                    /* <Grid item xs={12} md={6}>
                        <Paper elevation={2} sx={{ p: 3, height: '100%' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                <NotificationsIcon color="primary" sx={{ mr: 1 }} />
                                <Typography variant="h6">
                                    Notifications
                                </Typography>
                            </Box>
                            <Divider sx={{ mb: 3 }} />

                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                <Typography variant="body1" sx={{ mr: 2 }}>
                                    Enable Notifications
                                </Typography>
                                <Switch
                                    name="enableNotifications"
                                    checked={settings.enableNotifications}
                                    onChange={handleChange}
                                    color="primary"
                                />
                            </Box>

                            <Box sx={{ mb: 2 }}>
                                <Typography variant="body1" sx={{ mb: 1 }}>
                                    Low Stock Threshold
                                </Typography>
                                <TextField
                                    name="lowStockThreshold"
                                    type="number"
                                    value={settings.lowStockThreshold}
                                    onChange={handleNumberChange}
                                    fullWidth
                                    inputProps={{ min: 1 }}
                                    variant="outlined"
                                    size="small"
                                />
                            </Box>
                        </Paper>
                    </Grid> */

                    /* Sync Now Card */
                    /* <Grid item xs={12} md={6}>
                        <Paper elevation={2} sx={{ p: 3, height: '100%' }}>
                            <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                                <SyncIcon color="primary" sx={{ mr: 1 }} />
                                Data Synchronization
                            </Typography>
                            <Divider sx={{ mb: 3 }} />

                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<SyncIcon />}
                                onClick={handleManualSync}
                                fullWidth
                                sx={{ mb: 2 }}
                            >
                                Force Sync Data Now
                            </Button>

                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                mt: 2
                            }}>
                                <Typography variant="body2" color="text.secondary">
                                    Last sync status:
                                </Typography>
                                <Chip
                                    label={lastSync.toLocaleString()}
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                />
                            </Box>
                        </Paper>
                    </Grid> */